<template>
    <div class="sell_type">
        <van-icon name="cross" class="close" @click="close"/>
        <div class="tit">选择交易方式</div>
        <div class="sell_item" @click="puton(1)">
            <div class="left">
                <van-image :src="require('../../assets/bx/acc/type1.png')" class="icon"/>
                <span class="item_name">寄售角色</span>
                <van-icon name="question" class="question" @click.stop="question"/>
                <span class="tag">推荐</span>
            </div>
            <van-icon name="arrow" class="arrow"/>
        </div>
        <div class="sell_item qd" @click="puton(2)">
            <div class="left">
                <van-image :src="require('../../assets/bx/acc/type2.png')" class="icon"/>
                <span class="item_name">担保交易</span>
                <van-icon name="question" class="question" @click.stop="question2"/>
                <!-- <span class="tag">敬请期待</span> -->
            </div>
            <van-icon name="arrow" class="arrow"/>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    export default {
        props: ['selection'],
        data() {
            return {

            }
        },
        computed: {
            sellAgree() {
                return this.$store.state.sellAgree
            }
        },
        created() {},
        mounted() {},
        methods: {
            close() {
                this.$emit('handleClose')
            },
            question() {
                this.$RModal.saledes({
                    noheader: true,
                    front: true
                })
            },
            question2() {
                this.$RModal.dbdes({
                    noheader: true,
                    front: true
                })
            },
            funcPuton(otype) {
                var params = {
                    app_id: this.selection.app_id,
                    account_id: this.selection.account_id,
                    role_id: this.selection.role_id,
                    server_id:this.selection.server_id,
                    otype,//1寄售 2担保
                    account: this.selection.account,
                    role_name: this.selection.role_name,
                    server_name: this.selection.server_name,
                    child_user_id: this.selection.child_user_id
                }
                if(this.selection.from != '') params.from = this.selection.from
                setTimeout(() => {
                    $('.van-overlay').hide()
                    $('.global_popup').hide()
                },10)
                this.$store.commit('setPuton',JSON.stringify(params))
                setTimeout(() => {
                    this.$router.push({
                        name: 'acc.puton',
                        query: params
                    })
                },100)
            },
            //寄售角色
            puton(otype) {
                var that = this
                this.$emit('handleClose')
                if(this.sellAgree == 1) {
                    that.funcPuton(otype)
                    return
                }else {
                    this.$filterPop({
                        type: 'agree',
                        direction: 'fade',
                        onSuccess: () => {
                            that.funcPuton(otype)
                        }
                    })
                }
            },
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
.sell_type {
    padding: 2.4rem 1rem 3.6rem;
    position: relative;
    .close {
        position: absolute;
        right: 1rem;
        top: 1rem;
        font-size: 1.8rem;
        color: #000;
        cursor: pointer;
    }
    .tit {
        font-size: 1.6rem;
        font-weight: 700;
        text-align: center;
        color: #000;
        margin-bottom: 2rem;
    }
    .sell_item {
        height: 7.1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 1rem;
        background-color: #fffdee;
        padding: 0 1.2rem;
        margin-bottom: .8rem;
        cursor: pointer;
        .left {
            display: flex;
            align-items: center;
            .icon {
                width: 3.5rem;
                height: 3.3rem;
                margin-right: 1.3rem;
            }
            .item_name {
                font-size: 1.6rem;
                color: #000;
            }
            .question {
                color: #b4b4b4;
                font-size: 1.3rem;
                margin: 0 .5rem;
                cursor: pointer;
            }
            .tag {
                padding: 0 .6rem;
                font-size: 1.2rem;
                color: #ff0000;
                border: 1px solid #ff0000;
                border-radius: .3rem;
                transform: translateY(-.5rem) scale(0.8);
            }
        }
        .arrow {
            font-size: 1.4rem;
        }
        &.qd {
            background-color: #efefef;
            .left {
                .icon {
                    width: 3.9rem;
                    height: 3.1rem;
                    margin-right: 1rem;
                }
            }
        }
    }
}
</style>